<template>
	<div class="container__crud">
		<div
			class="container__crudactions"
			style="flex-flow: row nowrap"
		>
			<div class="container__crudactions_cruddownload">
				<div class="container__crudactions__cruddownload__crud" />
			</div>
			<MultiSelect
				v-model="fazendasEscolhidas"
				style="padding-right: 20px"
				:label="$t('farm')"
				:options="fazendas"
			/>

			<MultiSelect
				v-model="inventariosEscolhidos"
				style="padding-right: 20px"
				:label="$t('forestInventory')"
				:options="inventarios"
			/>
		</div>

		<div class="container__niveis_de_exportacao">
			<label>{{ $t('nivelDaExportacao') }}</label>
			<RadioButton
				id="estrato"
				v-model="nivelDeExportacao"
				:label="$t('stratum')"
				model-value="estrato"
				name="nivel-exportacao"
			/>
			<RadioButton
				id="plantio"
				v-model="nivelDeExportacao"
				:label="$t('plantation')"
				model-value="plantio"
				name="nivel-exportacao"
			/>
			<RadioButton
				id="pilha"
				v-model="nivelDeExportacao"
				:label="$t('pilha')"
				model-value="pilha"
				name="nivel-exportacao"
			/>
			<RadioButton
				id="tora"
				v-model="nivelDeExportacao"
				:label="$t('tora')"
				model-value="tora"
				name="nivel-exportacao"
			/>
		</div>

		<Button
			style="margin-left: auto !important; margin-right: 20px !important"
			:label="$t('export')"
			color="trv-default"
			semantic-class="tiny"
			width-auto
			@click="exportar"
		/>
	</div>
</template>

<script>
import Button from '../../../components/Button/Button'
import MultiSelect from '../../../components/MultiSelect/MultiSelect'
import RadioButton from '../../../components/RadioButton/RadioButton'

import {
	getDropdownPilha,
	getInventarioPilhaEstratoCsv,
	getInventarioPilhaPlantioCsv,
	getInventarioPilhaPilhaCsv,
	getInventarioPilhaToraCsv,
} from '../../../services/requests/ExportacaoRequests.js'

export default {
	components: {
		Button,
		MultiSelect,
		RadioButton,
	},
	data() {
		return {
			dropdown: [],
			fazendasEscolhidas: [],
			inventariosEscolhidos: [],
			nivelDeExportacao: 'estrato',
		}
	},
	computed: {
		fazendas() {
			return this.dropdown.map((m) => {
				return Object.assign(m, { label: m.fazenda, value: m.fazendaId })
			})
		},
		inventarios() {
			const processamentos = []
			const fazendas = this.dropdown.filter((f) => this.fazendasEscolhidas.includes(f.fazendaId))
			fazendas.forEach((el) => {
				el.processamentos.forEach((elm) => {
					elm.value = elm.estratoInventarioPilhaId
					elm.label = elm.descricao
					processamentos.push(elm)
				})
			})
			console.log(processamentos)
			return processamentos
		},
		dadoFormatado() {
			return {
				TipoExportacao: 'Default',
				processamentos: this.inventarios.filter((f) =>
					this.inventariosEscolhidos.includes(f.estratoInventarioPilhaId),
				),
			}
		},
	},
	async created() {
		const response = await getDropdownPilha()
		console.log('🚀 ~ file: InventarioArvore.vue ~ line 59 ~ created ~ response', response)
		this.dropdown = response.data.result
	},
	methods: {
		async exportar() {
			const response = await this.recuperarNivelDeExportacao()
			var a = document.createElement('a')
			a.target = '_blank'
			a.href = response.data.message
			document.body.appendChild(a)
			a.click()
			document.body.removeChild(a)
			console.log('🚀 ~ file: InventarioArvore.vue ~ line 68 ~ export ~ response', response)
		},
		recuperarNivelDeExportacao() {
			if (this.nivelDeExportacao === 'estrato')
				return getInventarioPilhaEstratoCsv(this.dadoFormatado)
			if (this.nivelDeExportacao === 'plantio')
				return getInventarioPilhaPlantioCsv(this.dadoFormatado)
			if (this.nivelDeExportacao === 'pilha') return getInventarioPilhaPilhaCsv(this.dadoFormatado)
			if (this.nivelDeExportacao === 'tora') return getInventarioPilhaToraCsv(this.dadoFormatado)

			throw new Error('Opção de exportação inválida')
		},
	},
}
</script>

<style scoped src="../../../css/crud.css"></style>

<style scoped>
.container__niveis_de_exportacao {
	display: flex;
	flex-direction: column;
	margin-top: 16px;
}

.container__niveis_de_exportacao > label {
	color: var(--color-navy-blue);
	font-weight: 400;
	margin-top: 0.5rem !important;
	margin-bottom: 0px !important;
	font-size: 0.8rem;
}
</style>
